import React from "react";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../data/brand";

export default function FloatingWhatsApp() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Contactar por WhatsApp"
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-3"
    >
      <span className="hidden rounded-full bg-white px-3 py-1.5 text-xs font-medium text-slate-700 shadow-md ring-1 ring-slate-200 sm:inline-block">
        ¿Hablamos?
      </span>
      <span className="relative grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-xl shadow-emerald-500/30 transition-transform group-hover:scale-105">
        <span className="absolute inset-0 animate-pulse-ring rounded-full" />
        <MessageCircle className="h-6 w-6" />
      </span>
    </a>
  );
}
